export default __webpack_public_path__ + "static/media/city-icon.166035b3.svg";